import type { ReportTemplate } from '../../schemas';

export const CENTRALI_SECTIONS_PRIMARY: ReportTemplate['sections'] = [
  {
    id: 'sec_caratteristiche-impianto-unit-name',
    name: 'Caratteristiche impianto — {{unit.name}}',
    type: 'repeating',
    repeat: {
      forEach: 'site.refrigerationUnits',
      as: 'unit',
    },
    fields: [
      {
        id: 'fld_nome-unita',
        label: 'Nome impianto',
        type: 'text',
        source: '{{unit.name}}',
        required: true,
        _idHistory: {
          derivedFrom: 'Nome impianto',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ubicazione',
        label: 'Ubicazione',
        type: 'text',
        source: '{{unit.location}}',
        _idHistory: {
          derivedFrom: 'Ubicazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_tipo-sistema-gas',
        label: 'Tipologia impianto',
        type: 'text',
        source: '{{unit.impiantoType}}',
        placeholder: 'Es: NH3 diretto, logistica del freddo, ecc.',
        _idHistory: {
          derivedFrom: 'Tipologia impianto',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ammoniaca-kg',
        label: 'Ammoniaca (kg)',
        type: 'number',
        source: '{{unit.ammoniaKg}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Ammoniaca (kg)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_compressori',
        label: 'Compressori',
        type: 'number',
        source: '{{unit.components.compressors}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Compressori',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_separatori-olio-nh3',
        label: 'Separatori olio/NH3',
        type: 'number',
        source: '{{unit.components.oilSeparators}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Separatori olio/NH3',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_separatori-l-g',
        label: 'Separatori L/G',
        type: 'number',
        source: '{{unit.components.lgSeparators}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Separatori L/G',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ricevitori',
        label: 'Ricevitori',
        type: 'number',
        source: '{{unit.components.receivers}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Ricevitori',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_condensatori',
        label: 'Condensatori',
        type: 'number',
        source: '{{unit.components.condensers}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Condensatori',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_scambiatori',
        label: 'Scambiatori',
        type: 'number',
        source: '{{unit.components.exchangers}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Scambiatori',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_pompe-nh3',
        label: 'Pompe NH3',
        type: 'number',
        source: '{{unit.components.nh3Pumps}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Pompe NH3',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_evaporatori-esterni',
        label: 'Evaporatori esterni',
        type: 'number',
        source: '{{unit.components.externalEvaporators}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Evaporatori esterni',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_benda-grassa-bt-presente',
        label: 'Benda grassa BT presente',
        type: 'bool',
        source: '{{unit.components.btGreaseBand}}',
        _idHistory: {
          derivedFrom: 'Benda grassa BT presente',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_nome-societa',
        label: 'Nome società',
        type: 'text',
        source: '{{unit.maintenanceContractor.name}}',
        _idHistory: {
          derivedFrom: 'Nome società',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_componenti-impianto',
        label: 'Componenti impianto',
        fieldIds: ['fld_nome-unita', 'fld_ubicazione', 'fld_tipo-sistema-gas', 'fld_ammoniaca-kg'],
      },
      {
        id: 'row_componenti',
        label: 'Componenti',
        fieldIds: [
          'fld_compressori',
          'fld_separatori-olio-nh3',
          'fld_separatori-l-g',
          'fld_ricevitori',
          'fld_condensatori',
          'fld_scambiatori',
          'fld_pompe-nh3',
          'fld_evaporatori-esterni',
          'fld_benda-grassa-bt-presente',
        ],
      },
      {
        id: 'row_societa-manutenzione',
        label: 'Società manutenzione',
        fieldIds: ['fld_nome-societa'],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'centrali',
      label: 'Impianti',
      order: 2,
      icon: 'factory',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_caratteristiche-impianto-sicurezza-u',
    name: 'Caratteristiche impianto sicurezza — {{unit.name}}',
    type: 'repeating',
    repeat: {
      forEach: 'site.refrigerationUnits',
      as: 'unit',
    },
    fields: [
      {
        id: 'fld_n-sensori-soffitto',
        label: 'N. sensori soffitto',
        type: 'number',
        source: '{{unit.safety.detectors.ceilingCount}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'N. sensori soffitto',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_n-sensori-altezza-uomo',
        label: 'N. sensori altezza uomo',
        type: 'number',
        source: '{{unit.safety.detectors.humanHeightCount}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'N. sensori altezza uomo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_posizioni-sensori',
        label: 'Posizioni sensori',
        type: 'text',
        format: 'multiline',
        source: '{{unit.safety.detectors.positionsText}}',
        placeholder: 'Soffitto zona compressori\nAltezza uomo ingresso',
        _idHistory: {
          derivedFrom: 'Posizioni sensori',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_soglie-e-interventi',
        label: 'Soglie e interventi',
        type: 'text',
        format: 'multiline',
        source: '{{unit.safety.detectors.thresholdsText}}',
        placeholder:
          '25 ppm: ottico-acustico, combinatore\n50 ppm: estrattori + scrubber\n1000 ppm: sgancio EE',
        _idHistory: {
          derivedFrom: 'Soglie e interventi',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_conformita-autorizzazione',
        label: 'Conformità autorizzazione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        _idHistory: {
          derivedFrom: 'Conformità autorizzazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_valutazione-del-direttore-tecnico',
        label: 'Valutazione del Direttore Tecnico',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: 'Osservazioni del Direttore Tecnico sulle soglie e sugli interventi',
        _idHistory: {
          derivedFrom: 'Valutazione del Direttore Tecnico',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_combinatore-telefonico',
        label: 'Combinatore telefonico',
        type: 'bool',
        source: '{{unit.safety.emergencySystems.dialerPresent}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'Combinatore telefonico',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_guardiania',
        label: 'Guardiania',
        type: 'bool',
        source: '{{unit.safety.emergencySystems.guardServicePresent}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'Guardiania',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_presente',
        label: 'Presente',
        type: 'bool',
        source: '{{unit.safety.ventilation.naturalPresent}}',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        _idHistory: {
          derivedFrom: 'Presente',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_aperture-alte-m',
        label: 'Aperture alte (m²)',
        type: 'number',
        source: '{{unit.safety.ventilation.apertureHighM2}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Aperture alte (m²)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_aperture-basse-m',
        label: 'Aperture basse (m²)',
        type: 'number',
        source: '{{unit.safety.ventilation.apertureLowM2}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Aperture basse (m²)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_numero-riserva',
        label: 'Numero (+ riserva)',
        type: 'number',
        source: '{{unit.safety.ventilation.extractorsCount}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Numero (+ riserva)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_portata-totale-m-h',
        label: 'Portata totale (m³/h)',
        type: 'number',
        source: '{{unit.safety.ventilation.extractorsFlowM3h}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Portata totale (m³/h)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_funzionamento-progettato',
        label: 'Funzionamento progettato',
        type: 'choice',
        source: '{{unit.safety.ventilation.extractorsOperation}}',
        options: [
          {
            value: 'prima_soglia',
            label: 'PRIMA SOGLIA',
          },
          {
            value: 'seconda_soglia',
            label: 'SECONDA SOGLIA',
          },
          {
            value: 'manuale',
            label: 'MANUALE',
          },
        ],
        _idHistory: {
          derivedFrom: 'Funzionamento progettato',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_atex',
        label: 'ATEX',
        type: 'bool',
        source: '{{unit.safety.ventilation.extractorsAtex}}',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        _idHistory: {
          derivedFrom: 'ATEX',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_presente_2',
        label: 'Presente',
        type: 'bool',
        source: '{{unit.safety.scrubber.present}}',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        _idHistory: {
          derivedFrom: 'Presente',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_portata-aria-m-h',
        label: 'Portata aria (m³/h)',
        type: 'number',
        source: '{{unit.safety.scrubber.airFlowM3h}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Portata aria (m³/h)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_portata-acqua',
        label: 'Portata acqua',
        type: 'text',
        format: 'multiline',
        source: '{{unit.safety.scrubber.waterFlowSpec}}',
        placeholder: 'n.20 ugelli da 7,95 l/min a 3 bar',
        _idHistory: {
          derivedFrom: 'Portata acqua',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_tempo-contatto-s',
        label: 'Tempo contatto (s)',
        type: 'number',
        source: '{{unit.safety.scrubber.contactTimeS}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Tempo contatto (s)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_atex_2',
        label: 'ATEX',
        type: 'bool',
        source: '{{unit.safety.scrubber.atex}}',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        _idHistory: {
          derivedFrom: 'ATEX',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_alimentazione-idrica',
        label: 'Alimentazione idrica',
        type: 'text',
        source: '{{unit.safety.scrubber.waterSupply}}',
        _idHistory: {
          derivedFrom: 'Alimentazione idrica',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_raccolta-acque',
        label: 'Raccolta acque',
        type: 'text',
        source: '{{unit.safety.scrubber.waterCollection}}',
        _idHistory: {
          derivedFrom: 'Raccolta acque',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_presente_3',
        label: 'Presente',
        type: 'bool',
        source: '{{unit.safety.abatementSystem.present}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'Presente',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_n-collettori-scarico',
        label: 'N. collettori scarico',
        type: 'number',
        source: '{{unit.safety.vsRelief.collectorsCount}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'N. collettori scarico',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_dimensionamento',
        label: 'Dimensionamento',
        type: 'text',
        source: '{{unit.safety.vsRelief.sizing}}',
        placeholder: 'DN100',
        _idHistory: {
          derivedFrom: 'Dimensionamento',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_costruzione',
        label: 'Costruzione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        _idHistory: {
          derivedFrom: 'Costruzione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_installazione',
        label: 'Installazione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        _idHistory: {
          derivedFrom: 'Installazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_volume-mc',
        label: 'Volume (mc)',
        type: 'number',
        source: '{{unit.safety.abatementTank.volumeMc}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Volume (mc)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_volume-minimo-necessario-mc',
        label: 'Volume minimo necessario (mc)',
        type: 'number',
        source: '{{unit.safety.abatementTank.minWaterMc}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Volume minimo necessario (mc)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_volume-minimo-libero-mc',
        label: 'Volume minimo libero (mc)',
        type: 'number',
        source: '{{unit.safety.abatementTank.minFreeMc}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Volume minimo libero (mc)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ubicazione',
        label: 'Ubicazione',
        type: 'choice',
        source: '{{unit.safety.abatementTank.location}}',
        options: [
          {
            value: 'interrata',
            label: 'Interrata',
          },
          {
            value: 'fuori_terra',
            label: 'Fuori terra',
          },
        ],
        _idHistory: {
          derivedFrom: 'Ubicazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_segnalata',
        label: 'Segnalata',
        type: 'choice',
        source: '{{unit.safety.abatementTank.signage}}',
        options: [
          {
            value: 'segnalata',
            label: 'Sì',
          },
          {
            value: 'non_segnalata',
            label: 'No',
          },
        ],
        _idHistory: {
          derivedFrom: 'Segnalata',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_accessibilita',
        label: 'Accessibilità',
        type: 'choice',
        source: '{{unit.safety.abatementTank.accessibility}}',
        options: [
          {
            value: 'agevole',
            label: 'Agevole',
          },
          {
            value: 'difficoltosa',
            label: 'Difficoltosa',
          },
        ],
        _idHistory: {
          derivedFrom: 'Accessibilità',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_materiale',
        label: 'Materiale',
        type: 'choice',
        source: '{{unit.safety.abatementTank.material}}',
        options: [
          {
            value: 'ca',
            label: 'C.A.',
          },
          {
            value: 'acciaio_zincato',
            label: 'Acciaio zincato',
          },
          {
            value: 'vetroresina',
            label: 'Vetroresina',
          },
          {
            value: 'polietilene',
            label: 'Polietilene',
          },
        ],
        _idHistory: {
          derivedFrom: 'Materiale',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_dimensioni',
        label: 'Dimensioni',
        type: 'text',
        source: '{{unit.safety.abatementTank.dimensions}}',
        placeholder: 'H=2m, L=3m',
        _idHistory: {
          derivedFrom: 'Dimensioni',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_orientamento',
        label: 'Orientamento',
        type: 'choice',
        source: '{{unit.safety.abatementTank.orientation}}',
        options: [
          {
            value: 'orizzontale',
            label: 'Orizzontale',
          },
          {
            value: 'verticale',
            label: 'Verticale',
          },
        ],
        _idHistory: {
          derivedFrom: 'Orientamento',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_controllo-livello-presente',
        label: 'Controllo livello presente',
        type: 'bool',
        source: '{{unit.safety.abatementTank.levelInstrumentation.present}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'Controllo livello presente',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_tipo-strumento-livello',
        label: 'Tipo strumento livello',
        type: 'choice',
        source: '{{unit.safety.abatementTank.levelInstrumentation.type}}',
        options: [
          {
            value: 'elettronico',
            label: 'Elettronico',
          },
          {
            value: 'meccanico',
            label: 'Meccanico',
          },
          {
            value: 'visivo',
            label: 'Visivo',
          },
        ],
        _idHistory: {
          derivedFrom: 'Tipo strumento livello',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_controllo-ph-continuo',
        label: 'Controllo pH continuo',
        type: 'bool',
        source: '{{unit.safety.abatementTank.continuousPhMonitoring}}',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        _idHistory: {
          derivedFrom: 'Controllo pH continuo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_linea-preferenziale',
        label: 'Linea preferenziale',
        type: 'bool',
        source: '{{unit.safety.abatementTank.emergencySupply.preferredLine}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'Linea preferenziale',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_gruppo-elettrogeno',
        label: 'Gruppo elettrogeno',
        type: 'bool',
        source: '{{unit.safety.abatementTank.emergencySupply.generator}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'Gruppo elettrogeno',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ups',
        label: 'UPS',
        type: 'bool',
        source: '{{unit.safety.abatementTank.emergencySupply.ups}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'UPS',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_conformita',
        label: 'Conformità',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        _idHistory: {
          derivedFrom: 'Conformità',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_valigetta-documenti-vvf',
        label: 'Valigetta documenti VVF',
        type: 'choice',
        source: '{{unit.safety.vvfDocs}}',
        options: [
          {
            value: 'prevista',
            label: 'Prevista',
          },
          {
            value: 'non_prevista',
            label: 'Non prevista',
          },
        ],
        _idHistory: {
          derivedFrom: 'Valigetta documenti VVF',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ubicazione-valigetta',
        label: 'Ubicazione valigetta',
        type: 'text',
        source: '{{unit.safety.vvfDocsLocation}}',
        _idHistory: {
          derivedFrom: 'Ubicazione valigetta',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_sistema-rilevazione-nh',
        label: 'Sistema rilevazione NH₃',
        fieldIds: [
          'fld_n-sensori-soffitto',
          'fld_n-sensori-altezza-uomo',
          'fld_posizioni-sensori',
          'fld_soglie-e-interventi',
          'fld_conformita-autorizzazione',
          'fld_valutazione-del-direttore-tecnico',
          'fld_combinatore-telefonico',
          'fld_guardiania',
        ],
      },
      {
        id: 'row_ventilazione-naturale',
        label: 'Ventilazione naturale',
        fieldIds: ['fld_presente', 'fld_aperture-alte-m', 'fld_aperture-basse-m'],
      },
      {
        id: 'row_estrattori-aria-forzata',
        label: 'Estrattori aria forzata',
        fieldIds: [
          'fld_numero-riserva',
          'fld_portata-totale-m-h',
          'fld_funzionamento-progettato',
          'fld_atex',
        ],
      },
      {
        id: 'row_scrubber',
        label: 'Scrubber',
        fieldIds: [
          'fld_presente_2',
          'fld_portata-aria-m-h',
          'fld_portata-acqua',
          'fld_tempo-contatto-s',
          'fld_atex_2',
          'fld_alimentazione-idrica',
          'fld_raccolta-acque',
        ],
      },
      {
        id: 'row_impianto-abbattimento',
        label: 'Impianto abbattimento',
        fieldIds: ['fld_presente_3'],
      },
      {
        id: 'row_abbattimento-nh3-da-vs',
        label: 'Abbattimento NH3 da VS',
        fieldIds: [
          'fld_n-collettori-scarico',
          'fld_dimensionamento',
          'fld_costruzione',
          'fld_installazione',
        ],
      },
      {
        id: 'row_vasca-abbattimento-nh3',
        label: 'Vasca abbattimento NH3',
        fieldIds: [
          'fld_volume-mc',
          'fld_volume-minimo-necessario-mc',
          'fld_volume-minimo-libero-mc',
          'fld_ubicazione',
          'fld_segnalata',
          'fld_accessibilita',
          'fld_materiale',
          'fld_dimensioni',
          'fld_orientamento',
        ],
      },
      {
        id: 'row_strumentazione-vasca',
        label: 'Strumentazione vasca',
        fieldIds: [
          'fld_controllo-livello-presente',
          'fld_tipo-strumento-livello',
          'fld_controllo-ph-continuo',
        ],
      },
      {
        id: 'row_alimentazione-emergenza-vasca',
        label: 'Alimentazione emergenza vasca',
        fieldIds: [
          'fld_linea-preferenziale',
          'fld_gruppo-elettrogeno',
          'fld_ups',
          'fld_conformita',
        ],
      },
      {
        id: 'row_altri-sistemi',
        label: 'Altri sistemi',
        fieldIds: ['fld_valigetta-documenti-vvf', 'fld_ubicazione-valigetta'],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'centrali',
      label: 'Impianti',
      order: 2,
      icon: 'factory',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_impianto-abbattimento-unit-name',
    name: 'Impianto abbattimento — {{unit.name}}',
    type: 'repeating',
    repeat: {
      forEach: 'site.refrigerationUnitsWithAbatementSystem',
      as: 'unit',
    },
    fields: [
      {
        id: 'fld_modalita-controllo',
        label: 'Modalità controllo',
        type: 'choice',
        source: '{{unit.safety.abatementSystem.controlMode}}',
        options: [
          {
            value: 'manuale',
            label: 'Manuale',
          },
          {
            value: 'automatico',
            label: 'Automatico',
          },
        ],
        _idHistory: {
          derivedFrom: 'Modalità controllo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_trim-presente',
        label: 'Trim presente',
        type: 'bool',
        source: '{{unit.safety.abatementSystem.trim}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Assente',
          },
        },
        _idHistory: {
          derivedFrom: 'Trim presente',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_finecorsa-presenti',
        label: 'Finecorsa presenti',
        type: 'bool',
        source: '{{unit.safety.abatementSystem.limitSwitches}}',
        formatting: {
          labels: {
            true: 'Presenti',
            false: 'Assenti',
          },
        },
        _idHistory: {
          derivedFrom: 'Finecorsa presenti',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_tipologia',
        label: 'Tipologia',
        type: 'text',
        format: 'multiline',
        source: '{{unit.safety.abatementSystem.type}}',
        placeholder: 'Descrizione sistema (es. Scrubber centralizzato)',
        _idHistory: {
          derivedFrom: 'Tipologia',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_alimentazione',
        label: 'Alimentazione',
        type: 'text',
        source: '{{unit.safety.abatementSystem.supply}}',
        _idHistory: {
          derivedFrom: 'Alimentazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_scarico',
        label: 'Scarico',
        type: 'text',
        source: '{{unit.safety.abatementSystem.disposal}}',
        _idHistory: {
          derivedFrom: 'Scarico',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_portata-acqua-m-h',
        label: 'Portata acqua (m³/h)',
        type: 'number',
        source: '{{unit.safety.abatementSystem.waterFlowM3h}}',
        validation: {
          min: 0,
        },
        _idHistory: {
          derivedFrom: 'Portata acqua (m³/h)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_controllo-e-comando',
        label: 'Controllo e comando',
        fieldIds: ['fld_modalita-controllo', 'fld_trim-presente', 'fld_finecorsa-presenti'],
      },
      {
        id: 'row_caratteristiche',
        label: 'Caratteristiche',
        fieldIds: ['fld_tipologia', 'fld_alimentazione', 'fld_scarico', 'fld_portata-acqua-m-h'],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'centrali',
      label: 'Impianti',
      order: 2,
      icon: 'factory',
    },
    layout: {
      columns: 2,
    },
  },
];

export const CENTRALI_SECTIONS_CONTROLLI: ReportTemplate['sections'] = [
  {
    id: 'sec_controlli-impianto-di-sicurezza',
    name: 'Controlli impianto di sicurezza — {{check.unitName}}',
    type: 'repeating',
    repeat: {
      forEach: 'visit.detailedChecks',
      as: 'check',
    },
    fields: [
      {
        id: 'fld_unita',
        label: 'Impianto',
        type: 'text',
        source: '{{check.unitName}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Impianto',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_elemento-controllato',
        label: 'Elemento controllato',
        type: 'text',
        source: '{{check.item}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Elemento controllato',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_esito',
        label: 'Esito',
        type: 'choice',
        source: '{{check.result}}',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
          {
            value: 'non_verificabile',
            label: 'Non verificabile',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Esito',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_verifica-eseguita-da',
        label: 'Verifica eseguita da',
        type: 'choice',
        source: '{{check.verifiedBy}}',
        options: [
          {
            value: 'DT',
            label: 'DT - Direttore Tecnico',
          },
          {
            value: 'PP',
            label: 'PP - Personale Patentato',
          },
          {
            value: 'RP',
            label: 'RP - Rapporto Precedente',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Verifica eseguita da',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_note',
        label: 'Note',
        type: 'text',
        format: 'multiline',
        source: '{{check.notes}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'centrali',
      label: 'Impianti',
      order: 2,
      icon: 'factory',
    },
    layout: {
      columns: 2,
    },
  },
];
